import { getOrderSuggestionList } from '@/store/api/fbm'

const types = {
  CHANGE_CONVERSATIONS_BOX_VISIBLE: 'CHANGE_CONVERSATIONS_BOX_VISIBLE',
  CHANGE_MESSAGES_BOX_VISIBLE: 'CHANGE_MESSAGES_BOX_VISIBLE',

  SET_FB_PAGE_ACCOUNT_STATUS: 'SET_FB_PAGE_ACCOUNT_STATUS',

  SET_LOADING_PAGE: 'SET_LOADING_PAGE',
  SET_PAGE_LIST: 'SET_PAGE_LIST',
  SET_ACTIVE_PAGE: 'SET_ACTIVE_PAGE',

  SET_LOADING_CONVERSATION: 'SET_LOADING_CONVERSATION',
  SET_CONVERSATION_LIST: 'SET_CONVERSATION_LIST',
  ADD_MORE_CONVERSATIONS_TO_LIST: 'ADD_MORE_CONVERSATIONS_TO_LIST',

  SET_LOADING_MESSAGE: 'SET_LOADING_MESSAGE',
  SET_MESSAGE_LIST: 'SET_MESSAGE_LIST',
  ADD_MORE_MESSAGES_TO_LIST: 'ADD_MORE_MESSAGES_TO_LIST',

  SET_IGNORED_CONVERSATION: 'SET_IGNORED_CONVERSATION',

  SET_ORDER_SUGGESTIONS: 'SET_ORDER_SUGGESTIONS',
  SET_LOADING_ORDER_SUGGESTIONS: 'SET_LOADING_ORDER_SUGGESTIONS'
}

const state = {
  is_required_login: false,
  is_session_expired: false,
  no_permission: false,
  no_account_available: false,

  loading_page: false,
  page_list: null,
  active_page: null,

  conversations_box_visible: false,
  loading_conversation: false,
  conversation_list: null,

  messages_box_visible: false,
  loading_message: false,
  message_list: null,

  ignored_conversation_ids: [],

  order_suggestions: [],
  loading_order_suggestions: false
}

const getters = {
  orderSuggestions: (state) => state.order_suggestions,
  loadingOrderSuggestions: (state) => state.loading_order_suggestions,

  fbPageAccountStatus: (state) => {
    return {
      is_required_login: state.is_required_login,
      is_session_expired: state.is_session_expired,
      no_permission: state.no_permission,
      no_account_available: state.no_account_available
    }
  },
  loadingPages: (state) => state.loading_page,
  pageList: (state) => state.page_list,
  activePage: (state) => state.active_page,

  conversationsBoxVisible: (state) => state.conversations_box_visible,
  loadingConversations: (state) => {
    return state.loading_conversation && !state.conversation_list
  },
  loadingMoreConversations: (state) => {
    return (
      state.loading_conversation &&
      state.conversation_list &&
      state.conversation_list.data &&
      state.conversation_list.data.length > 0
    )
  },
  conversationList: (state) => state.conversation_list,
  noConverationsAvailable: (state) => {
    const conversations = state.conversation_list && state.conversation_list.data
    return !state.loading_conversation && conversations && !conversations[0]
  },

  messagesBoxVisible: (state) => state.messages_box_visible,
  loadingMessages: (state) => {
    return state.loading_message && (!state.message_list || !state.message_list.data)
  },
  loadingMoreMessages: (state) => {
    return (
      state.loading_message &&
      state.message_list &&
      state.message_list.data &&
      state.message_list.data.length > 0
    )
  },
  messageList: (state) => state.message_list,
  ignoredConversationIds: (state) => state.ignored_conversation_ids
}

const actions = {
  // Order Suggestions
  setLoadingOrderSuggestions({ commit }, value) {
    commit(types.SET_LOADING_ORDER_SUGGESTIONS, value)
  },
  getOrderSuggestions({ commit }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      commit(types.SET_LOADING_ORDER_SUGGESTIONS, true)

      let data
      try {
        data = await getOrderSuggestionList({})
      } catch (error) {
        commit(types.SET_LOADING_ORDER_SUGGESTIONS, false)
        return reject(error)
      }

      commit(types.SET_LOADING_ORDER_SUGGESTIONS, false)

      const filterResult =
        data &&
        data.filter((item) => {
          return !item.found_order || item.found_order.status !== 'COMPLETED'
        })

      commit(types.SET_ORDER_SUGGESTIONS, filterResult)
      resolve(filterResult)
    })
  },
  // END Order Suggestions

  showConversationsBox({ commit }) {
    commit(types.CHANGE_CONVERSATIONS_BOX_VISIBLE, true)
  },
  hideConversationsBox({ commit }) {
    commit(types.CHANGE_CONVERSATIONS_BOX_VISIBLE, false)
  },
  showMessagesBox({ commit }) {
    commit(types.CHANGE_MESSAGES_BOX_VISIBLE, true)
  },
  hideMessagesBox({ commit }) {
    commit(types.CHANGE_MESSAGES_BOX_VISIBLE, false)
  },
  setFBAccountStatus({ commit }, value) {
    commit(types.SET_FB_PAGE_ACCOUNT_STATUS, value)
  },
  setLoadingPage({ commit }, value) {
    commit(types.SET_LOADING_PAGE, value)
  },
  setPageList({ commit }, value) {
    commit(types.SET_PAGE_LIST, value)
  },
  setActivePage({ commit }, value) {
    commit(types.SET_ACTIVE_PAGE, value)
  },
  setLoadingConversation({ commit }, value) {
    commit(types.SET_LOADING_CONVERSATION, value)
  },
  setConversationList({ commit, state }, value) {
    commit(types.SET_CONVERSATION_LIST, value)

    let pageList = state.page_list
    const activePageId = state.active_page.id
    const conversationList = state.conversation_list
    const foundIndex = pageList.data.findIndex((p) => {
      return p.id === activePageId
    })
    if (foundIndex > -1) {
      pageList.data[foundIndex].conversations = conversationList
      commit(types.SET_PAGE_LIST, pageList)
    }
  },
  setAddMoreConversationsToList({ commit }, value) {
    commit(types.ADD_MORE_CONVERSATIONS_TO_LIST, value)

    let pageList = state.page_list
    const activePageId = state.active_page.id
    const conversationList = state.conversation_list
    const foundIndex = pageList.data.findIndex((p) => {
      return p.id === activePageId
    })
    if (foundIndex > -1) {
      pageList.data[foundIndex].conversations = conversationList
      commit(types.SET_PAGE_LIST, pageList)
    }
  },
  setLoadingMessage({ commit }, value) {
    commit(types.SET_LOADING_MESSAGE, value)
  },
  setMessageList({ commit }, value) {
    commit(types.SET_MESSAGE_LIST, value)
  },
  setAddMoreMessagesToList({ commit }, value) {
    commit(types.ADD_MORE_MESSAGES_TO_LIST, value)
  },
  addIgnoredConversation({ commit, state }, conversation_id) {
    let list = state.ignored_conversation_ids
    const foundIndex = list.findIndex((i) => {
      return i === conversation_id
    })
    if (foundIndex === -1) {
      list.push(conversation_id)
      commit(types.SET_IGNORED_CONVERSATION, list)
    }
  },
  removeIgnoredConversation({ commit, state }, conversation_id) {
    let list = state.ignored_conversation_ids
    const foundIndex = list.findIndex((i) => {
      return i === conversation_id
    })
    if (foundIndex > -1) {
      list.splice(foundIndex, 1)
      commit(types.SET_IGNORED_CONVERSATION, list)
    }
  }
}

const mutations = {
  // ORDER SUGGESTION
  [types.SET_ORDER_SUGGESTIONS](state, data) {
    state.order_suggestions = data
  },
  [types.SET_LOADING_ORDER_SUGGESTIONS](state, value) {
    state.loading_order_suggestions = value
  },
  // END ORDER SUGGESTION

  [types.CHANGE_CONVERSATIONS_BOX_VISIBLE](state, value) {
    state.conversations_box_visible = value
  },
  [types.CHANGE_MESSAGES_BOX_VISIBLE](state, value) {
    state.messages_box_visible = value
  },
  [types.SET_FB_PAGE_ACCOUNT_STATUS](state, value) {
    const { is_required_login, is_session_expired, no_permission, no_account_available } =
      value || {}
    state.is_required_login = is_required_login
    state.is_session_expired = is_session_expired
    state.no_permission = no_permission
    state.no_account_available = no_account_available
  },
  [types.SET_LOADING_PAGE](state, value) {
    state.loading_page = value
  },
  [types.SET_PAGE_LIST](state, value) {
    state.page_list = value
  },
  [types.SET_ACTIVE_PAGE](state, value) {
    state.active_page = value
  },
  [types.SET_LOADING_CONVERSATION](state, value) {
    state.loading_conversation = value
  },
  [types.SET_CONVERSATION_LIST](state, value) {
    state.conversation_list = value
  },
  [types.ADD_MORE_CONVERSATIONS_TO_LIST](state, value) {
    state.conversation_list.data.push(...value.data)
    state.conversation_list.paging = value.paging
  },
  [types.SET_LOADING_MESSAGE](state, value) {
    state.loading_message = value
  },
  [types.SET_MESSAGE_LIST](state, value) {
    state.message_list = value
  },
  [types.ADD_MORE_MESSAGES_TO_LIST](state, value) {
    console.log('ADD_MORE_MESSAGES_TO_LIST value', value)
    state.message_list.data.push(...value.data)
    state.message_list.paging = value.paging
  },
  [types.SET_IGNORED_CONVERSATION](state, value) {
    state.ignored_conversation_ids = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
